<template>
    <!-- 商品管理 -->
    <el-tabs v-model="activeName">
        <el-tab-pane label="八月活动" name="ceping95">
            <div class="el-card pd20">
                <div class="main">
                    <!-- list-->
                    <div class="el-card pd20">
                        <div class="statistics-box">
                            <div class="statis-child on">
                                <div class="top">
                                    <h4>数据统计</h4>
                                </div>
                                <div class="bottom">
                                    <div class="box">
                                        <h5>{{count1}}</h5>
                                        <p>查看详情页</p>
                                    </div>
                                    <div class="box">
                                        <h5>{{count2}}</h5>
                                        <p>点击开始测评</p>
                                    </div>
                                    <div class="box">
                                        <h5>{{count3}}</h5>
                                        <p>查看测评报告</p>
                                    </div>
                                    <div class="box">
                                        <h5>{{count4}}</h5>
                                        <p>点击申请咨询</p>
                                    </div>
                                    <div class="box">
                                        <h5>{{count5}}</h5>
                                        <p>测评海报扫码</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="做自己节" name="ceping81">
            <div class="el-card pd20">
                <div class="main">
                    <!-- list-->
                    <div class="el-card pd20">
                        <div class="statistics-box">
                            <div class="statis-child on">
                                <div class="top">
                                    <h4>数据统计</h4>
                                </div>
                                <div class="bottom">
                                    <div class="box">
                                        <h5>{{count1}}</h5>
                                        <p>查看排行榜人数</p>
                                    </div>
                                    <div class="box">
                                        <h5>{{count2}}</h5>
                                        <p>查看报告完成人数</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
import { ceping_event } from "@/api/measurement";
export default {
    data() {
        return {
            activeName: 'ceping95',
            count1: null,
            count2: null,
            count3: null,
            count4: null,
            count5: null,
        }
    },
    watch: {
        activeName(newVal, oldVal) {
            this.pullData();
        }
    },
    methods: {
        pullData() {
            this.$showLoading();

            if(this.activeName == 'ceping81') {
                Promise.all([
                    // 查看排行榜人数
                    ceping_event({
                        cid: 81,
                        event: 'LookRank',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count1 = data.count;

                        return Promise.resolve(data.count);
                    }),
                    // 完成报告人数
                    ceping_event({
                        cid: 81,
                        event: 'CompleteReport',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count2 = data.count;

                        return Promise.resolve(data.count);
                    }),
                ]).catch(msg=> {
                    this.$message(msg || '请求失败');
                }).finally(res=>{
                    this.$hideLoading();
                });
            } else if (this.activeName == 'ceping95') {
                Promise.all([
                    ceping_event({
                        cid: 95,
                        event: 'ViewDetail',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count1 = data.count;

                        return Promise.resolve(data.count);
                    }),
                    ceping_event({
                        cid: 95,
                        event: 'ClickStart',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count2 = data.count;

                        return Promise.resolve(data.count);
                    }),
                    ceping_event({
                        cid: 95,
                        event: 'ViewReport',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count3 = data.count;

                        return Promise.resolve(data.count);
                    }),
                    ceping_event({
                        cid: 95,
                        event: 'ClickExternal',
                        uv: 1
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count4 = data.count;

                        return Promise.resolve(data.count);
                    }),
                    ceping_event({
                        cid: 95,
                        event: 'ViewDetail',
                        uv: 1,
                        lead_sid: 'not null',
                    }).then((data) => {
                        if (data.error > 0) {
                            return Promise.reject(data.msg);
                        }
                        this.count5 = data.count;

                        return Promise.resolve(data.count);
                    }),
                ]).catch(msg=> {
                    this.$message(msg || '请求失败');
                }).finally(res=>{
                    this.$hideLoading();
                });
            }
            
        }
    },
    created() {
        this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
    position: relative;
}

.statistics-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    // width: 100%;
    .statis-child {
        display: flex;
        flex-direction: column;
        align-content: center;
        border-radius: 15px;
        margin-left: 20px;
        background-color: #ffffff;

        &:first-child {
            margin-left: 0;
        }

        // width: 50%;
        flex: 1;

        .top {
            text-align: center;
            border-bottom: 1px solid #eeeeee;
            padding: 10px;

            h4 {
                font-size: 20px;
                margin: 0 auto 15px;
                color: #25b864;
            }

            p {
                font-size: 14px;
                margin: 0;
                color: #666666;
            }
        }

        .bottom {
            display: flex;
            justify-content: center;

            .box {
                padding: 15px;
                flex: 1;
                text-align: center;

                h5 {
                    font-size: 18px;
                    margin: 0 auto 8px;
                }

                p {
                    font-size: 14px;
                    margin: 0;
                    color: #666666;
                }
            }
        }
    }

    .statis-child.on {
        // margin-bottom: 20px;
    }
}

.box {
    margin-bottom: 20px;
}

.search {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.search.search-btn {
    flex: 1;
}

.search-gropu {
    flex: 1;
}

.search-gropu.on {
    flex: 1.5;
}

.search-child {
    margin-left: 20px;
    width: 200px;
}

.el-input {
    width: 200px;
}
</style>